// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useState } from "react";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import SoftSnackbar from "components/SoftSnackbar";

// Settings page components
import FormField from "layouts/pages/account/components/FormField";
import userProfileService from "services/userProfileService";

function ChangePassword() {
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    color: "info",
  });

  const passwordRequirements = [
    "Mindestens ein Sonderzeichen",
    "Mindestens 8 Zeichen",
    "Mindestens 1 Zahl ( Empfohlen: 2 )",
  ];

  const renderPasswordRequirements = passwordRequirements.map((item, key) => {
    const itemKey = `element-${key}`;

    return (
      <SoftBox key={itemKey} component="li" color="text" fontSize="1.25rem" lineHeight={1}>
        <SoftTypography variant="button" color="text" fontWeight="regular" verticalAlign="middle">
          {item}
        </SoftTypography>
      </SoftBox>
    );
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPasswordData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Simple validation
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setSnackbar({
        open: true,
        message: "Neue Passwörter stimmen nicht überein",
        color: "error",
      });
      return;
    }

    if (passwordData.newPassword.length < 8) {
      setSnackbar({
        open: true,
        message: "Das neue Passwort muss mindestens 8 Zeichen lang sein",
        color: "error",
      });
      return;
    }

    try {
      setLoading(true);
      await userProfileService.changePassword(passwordData);
      
      // Reset form after successful password change
      setPasswordData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      
      setSnackbar({
        open: true,
        message: "Passwort erfolgreich geändert",
        color: "success",
      });
    } catch (error) {
      console.error("Error changing password:", error);
      
      const errorMessage = error?.error || error?.message || "Fehler beim Ändern des Passworts";
      
      setSnackbar({
        open: true,
        message: errorMessage,
        color: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <Card id="change-password">
        <SoftBox p={3}>
          <SoftTypography variant="h5">Passwort ändern</SoftTypography>
        </SoftBox>
        <SoftBox component="form" pb={3} px={3} onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormField
                label="Aktuelles Passwort"
                placeholder="****************"
                name="currentPassword"
                value={passwordData.currentPassword}
                onChange={handleInputChange}
                inputProps={{ type: "password", autoComplete: "off" }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField
                label="Neues Passwort"
                placeholder="****************"
                name="newPassword"
                value={passwordData.newPassword}
                onChange={handleInputChange}
                inputProps={{ type: "password", autoComplete: "off" }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField
                label="Neues Passwort bestätigen"
                placeholder="****************"
                name="confirmPassword"
                value={passwordData.confirmPassword}
                onChange={handleInputChange}
                inputProps={{ type: "password", autoComplete: "off" }}
              />
            </Grid>
          </Grid>
          <SoftBox mt={6} mb={1}>
            <SoftTypography variant="h5">Passwort Anforderungen</SoftTypography>
          </SoftBox>
          <SoftBox mb={1}>
            <SoftTypography variant="body2" color="text">
              Beachten Sie, folgende Anforderungen:
            </SoftTypography>
          </SoftBox>
          <SoftBox
            display="flex"
            justifyContent="space-between"
            alignItems="flex-end"
            flexWrap="wrap"
          >
            <SoftBox component="ul" m={0} pl={3.25} mb={{ xs: 8, sm: 0 }}>
              {renderPasswordRequirements}
            </SoftBox>
            <SoftBox ml="auto">
              <SoftButton 
                variant="gradient" 
                color="dark" 
                size="small"
                type="submit"
                disabled={loading}
              >
                {loading ? "Wird geändert..." : "Passwort ändern"}
              </SoftButton>
            </SoftBox>
          </SoftBox>
        </SoftBox>
      </Card>
      <SoftSnackbar
        color={snackbar.color}
        icon="notifications"
        title="Hinweis"
        content={snackbar.message}
        open={snackbar.open}
        onClose={handleCloseSnackbar}
        close={handleCloseSnackbar}
        bgWhite
      />
    </>
  );
}

export default ChangePassword;
